// ============================================================================
// UKRAINIAN TRANSLATIONS - JESUS IS NOT
// ============================================================================
// Роз'яснення про те, хто є Ісус (і ким Він не є)

export const jesusIsNot = [
  {
    category: "любов",
    text: "Ісус не расист - Він любить усіх однаково, незалежно від їхнього походження",
    reference: "Івана 4:9 - Самарянка дивується, що Ісус говорить з нею",
    context: "Ісус долає культурні та расові бар'єри свого часу"
  },
  {
    category: "виключення",
    text: "Ісус не виключає - Він приймає всіх, особливо відкинутих",
    reference: "Матвія 9:10-13 - Ісус їсть з митниками та грішниками",
    context: "Ісус шукає загублених і відкинутих суспільством"
  },
  {
    category: "осуд",
    text: "Ісус не засуджує - Він прийшов рятувати, а не засуджувати",
    reference: "Івана 3:17 - Бог послав Сина не для засудження світу",
    context: "Місія Ісуса - порятунок і відновлення"
  },
  {
    category: "насильство",
    text: "Ісус не жорстокий - Він вчить любові до ворогів",
    reference: "Матвія 5:44 - Любіть ворогів ваших",
    context: "Ісус революціонізує концепцію справедливості радикальною любов'ю"
  },
  {
    category: "багатство",
    text: "Ісус не матеріаліст - Він застерігає від любові до грошей",
    reference: "Матвія 6:24 - Не можете служити Богові й мамоні",
    context: "Ісус ставить небесні скарби вище земних"
  },
  {
    category: "гордість",
    text: "Ісус не гордий - Він принижує себе і служить",
    reference: "Івана 13:5 - Ісус омиває ноги учням",
    context: "Ісус показує, що велич у смиренному служінні"
  },
  {
    category: "легалізм",
    text: "Ісус не легаліст - Він ставить милосердя вище ритуалу",
    reference: "Матвія 12:7 - Милості хочу, а не жертви",
    context: "Ісус критикує легалізм, що забуває серце закону"
  },
  {
    category: "стать",
    text: "Ісус не сексист - Він шанує і цінує жінок",
    reference: "Івана 4:27 - Учні дивуються, що Він говорить з жінкою",
    context: "Ісус кидає виклик патріархальним нормам своєї культури"
  },
  {
    category: "влада",
    text: "Ісус не тиран - Він веде з любов'ю і прикладом",
    reference: "Матвія 20:28 - Син Людський прийшов служити",
    context: "Ісус переосмислює лідерство як жертовне служіння"
  },
  {
    category: "помста",
    text: "Ісус не мстивий - Він прощає і відновлює",
    reference: "Луки 23:34 - Отче! прости їм, бо не знають, що роблять",
    context: "Ісус практикує радикальне прощення навіть на хресті"
  },
  {
    category: "байдужість",
    text: "Ісус не байдужий - Він співчуває страждаючим",
    reference: "Матвія 9:36 - Він змилосердився над народом",
    context: "Ісус виявляє глибоку емпатію до страждаючих"
  },
  {
    category: "еліта",
    text: "Ісус не елітарний - Він оточує себе простими людьми",
    reference: "Марка 1:16-20 - Ісус закликає рибалок учнями",
    context: "Ісус вибирає звичайних людей для своєї незвичайної місії"
  },
  {
    category: "лицемірство",
    text: "Ісус не лицемір - Він живе тим, чого вчить",
    reference: "Івана 8:46 - Хто з вас докаже Мені гріх?",
    context: "Ісус закликає знайти протиріччя між Його словами і діями"
  },
  {
    category: "жорсткість",
    text: "Ісус не жорсткий - Він адаптує навчання до кожної людини",
    reference: "Івана 3 - Ісус говорить з Никодимом інакше, ніж з самарянкою",
    context: "Ісус персоналізує своє послання відповідно до потреб кожного"
  },
  {
    category: "традиція",
    text: "Ісус не сліпий традиціоналіст - Він ставить під сумнів гнітючі традиції",
    reference: "Марка 7:13 - Усуваючи слово Боже переданням вашим",
    context: "Ісус ставить дух закону вище людських традицій"
  },
  {
    category: "націоналізм",
    text: "Ісус не націоналіст - Його царство виходить за межі кордонів",
    reference: "Матвія 28:19 - Ідіть, навчіть усі народи",
    context: "Місія Ісуса універсальна, не обмежена одним народом"
  },
  {
    category: "поділ",
    text: "Ісус не розділяє - Він молиться про єдність віруючих",
    reference: "Івана 17:21 - Нехай будуть усі одно",
    context: "Давайте святкувати нашу різноманітність замість словесних воєн"
  },
  {
    category: "правда",
    text: "Ісус не брехун - Він викриває брехню та маніпуляції",
    reference: "Івана 8:44 - Диявол - батько брехні",
    context: "Ісус викриває брехню та маніпуляції, що ранять душі"
  },
  {
    category: "щедрість",
    text: "Ісус не скупий - Його щедрість значно перевершує десятину",
    reference: "Луки 21:3 - Ця бідна вдова найбільше поклала",
    context: "Щедрість Ісуса сильніша за зобов'язання десятини"
  },
  {
    category: "справедливість",
    text: "Ісус не співучасник мовчання - Він захищає здоровою справедливістю",
    reference: "Матвія 18:6 - Хто спокусить одного з малих цих",
    context: "Мовчання, що приховує провину без захисту інших, - не мудрість Ісуса"
  }
];

export default jesusIsNot;
